// extracted by mini-css-extract-plugin
export default {"infoText":"style_infoText__dreRA","images":"style_images__z-e2o","hr":"style_hr__WNilB","pdfViewer":"style_pdfViewer__MNhY2"};